import React, {FC} from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownBoxCoordinator} from '../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {CutoffTimeProps, MassArchiveCutoffDropdown} from './massArchiveCutoffDropdown';

/*
 * Props.
 */

interface MassArchiveCutoffDropdownBoxProps {
  selectedCutoff: CutoffTimeProps;
  onCutoffSelect: HandlerOf<CutoffTimeProps>;
  showCustom?: boolean;
}

/*
 * Component.
 */

export const MassArchiveCutoffDropdownBox: FC<MassArchiveCutoffDropdownBoxProps> = (props) => (
  <DropdownBoxCoordinator
    value={props.selectedCutoff.label}
    renderDropdown={(popoverProps) => renderDropdown(popoverProps, props)}
  />
);

function renderDropdown(popoverProps: PopoverTransferProps, props: MassArchiveCutoffDropdownBoxProps) {
  return <MassArchiveCutoffDropdown {...popoverProps} {...props} width={popoverProps.anchorWidth} />;
}
